<template>
	<AppFooterWrapper class="move-step-footer" v-if="isMoveNodeActive" @cancel="setMoveStepLocationInTreeInactive">
		<span class="flex-centerize footer-text pointer-events-none">
			Click any
			<div class="mx-2 plus-btn flex-centerize">+</div>
			To move step location
		</span>
	</AppFooterWrapper>
</template>

<script>
import { mapActionsShorthand, mapGettersShorthand } from '@/store/utils/mappers';
import { isMoveNodeActive } from '@/store/modules/treeBlocks/getters';
import { setMoveStepLocationInTreeInactive } from '@/store/modules/treeBlocks/actions';

import AppFooterWrapper from './AppFooterWrapper';

export default {
	name: 'MoveStepFooter',
	components: {
		AppFooterWrapper,
	},
	computed: {
		...mapGettersShorthand({ isMoveNodeActive }),
	},
	methods: {
		...mapActionsShorthand({ setMoveStepLocationInTreeInactive }),
	},
};
</script>

<style scoped lang="scss">
.move-step-footer {
	&.v-footer {
		background-color: #ddf6f0 !important;
	}
	.footer-text {
		color: #35c5aa;
	}
}
.plus-btn {
	width: 30px;
	height: 30px;
	color: white;
	font-size: 20px;
	border-radius: 50%;
	background: #35c5aa;
}
</style>
